<template>
	<picture v-if="data instanceof Object">
		<source v-for="image in images" :media="`(min-width: ${image.breakpoint}px)`" :srcset="image.public_path" :type="`image/${image.format}`">
		<img :src="fallback.public_path" :alt="alt" :class="this.class">
	</picture>
	<img v-else :src="data.length > 0 ? data : legacyFallback" :class="this.class" :alt="alt" @error="brokenImage"/>
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
	name: "SeoImage",
	props: {
		data: {
			default: '',
		},
		class: {
			type: String,
			required: false,
		},
		alt: {
			type: String,
			required: false,
		},
		only: {
			type: Number,
			required: false,
		},
		legacyFallback: {
			type: String,
			default: '',
			required: false,
		}
	},
	computed: {
		images() {
			if (this.only) {
				return this.data.filter(x => x.size === this.only);
			}
			return this.data;
		},
		fallback() {
			return this.data.filter(x => x.type === 'small' && (x.format === 'jpg' || x.format === 'png'))[0];
		}
	},
	methods: {
		brokenImage(e: any): void {
			e.target.style.opacity = 0;
		}
	}
});
</script>
